var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAOElEQVR42mMYBTQC////P4MNE615y+bNWDFIjmgDerq7kTGyAWmUuoCwAbgwwgDCIA0fHk1mVAYAvuSCYw95K9wAAAAASUVORK5CYII=";
  export default img;